import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from '../../material.module';
import { MomentModule } from 'ngx-moment';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CategoryStreamsPipe } from './categoryStreams.pipe';
import { IncludedCategoryPipe } from './includedCategory.pipe';
import { SafeHtmlPipe } from './safeHtml.pipe';
import { SafeUrlPipe } from './safeUrl.pipe';

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MaterialModule,
        MomentModule,
        InfiniteScrollModule,
    ],
    declarations: [
        CategoryStreamsPipe,
        IncludedCategoryPipe,
        SafeHtmlPipe,
        SafeUrlPipe
    ],
    exports: [
        CategoryStreamsPipe,
        IncludedCategoryPipe,
        SafeHtmlPipe,
        SafeUrlPipe
    ]
})
export class PipesModule {
}